module.exports = __webpack_public_path__ + "static/media/bellabyte-ecommerce-store-site.ed3a08d4.jpg";